React = require 'react'
{ OrganizationBoardsAd } = require 'views/organization/organization-ad-component'
t = require('views/internal/recup-with-helpers')('board_list')
_ = require 'underscore'
ClientConfig = require 'debug/client-config'
{ trackUnsplashViewBySavedUrl } = require 'network/unsplash'

module.exports = class extends React.Component
  displayName: 'BoardListSectionComponent'
  constructor: (props) ->
    super(props)

    @state = {
      collapsed: true
    }

  componentDidMount: ->
    @trackUnsplashViews()

  componentDidUpdate: (prevProps) ->
    if !_.isEqual(@props.items, prevProps.items)
      @trackUnsplashViews()

  trackUnsplashViews: ->
    { items } = @props
    backgrounds = @getDisplayableItems()

    backgroundImages = backgrounds.map((background) ->
      background.props.background.image
    )
    backgroundImagesFiltered = backgroundImages.filter (bg) -> !!bg
    if backgroundImagesFiltered.length
      trackUnsplashViewBySavedUrl backgroundImagesFiltered

  getDisplayableItems: ->
    { items, mayBeSorted } = @props
    { collapsed } = @state
    displayableItems =
      if mayBeSorted
        _.chain items
          .sortBy (item) -> -(item.props.dateLastActivity)
          .filter (item, index) -> !collapsed || index <= 10 ||  !item.props.isLessActive
          .sortBy (item) -> item.props.name.toLowerCase()
          .value()
      else
        items
    return displayableItems

  render: t.renderable ->
    { items,
      header,
      noSidebarMod,
      createNewItem,
      mayBeSorted,
      showAd,
      isAdDismissed,
      privateBoardTiles } = @props
    boardCount = items.length
    displayedItems = @getDisplayableItems()

    lessActiveCount = boardCount - displayedItems.length

    classes = t.classify
      'boards-page-board-section': !showAd
      'mod-no-sidebar': noSidebarMod

    t.div { class: classes }, =>
      if header
        t.addElement header

      if showAd && !ClientConfig.get('dontUpsell')
        t.div '.boards-page-layout', =>
          t.div '.boards-page-layout-sidebar', =>
            t.div '.boards-page-ad-section', =>
              if !isAdDismissed
                t.addElement @orgAdComponent()
          t.div '.boards-page-layout-list', =>
            t.ul '.boards-page-board-section-list', =>
              for item in displayedItems
                t.addElement item
              if privateBoardTiles
                t.addElement privateBoardTiles
              if createNewItem
                t.addElement createNewItem
              return
      else
        t.ul '.boards-page-board-section-list', ->
          for item in displayedItems
            t.addElement item
          if privateBoardTiles
            t.addElement privateBoardTiles
          if createNewItem
            t.addElement createNewItem
          return

      onShowAllClick = =>
        @setState(collapsed: false)

      if displayedItems.length < items.length
        t.b onShowAllClick, '.boards-page-show-all-boards.quiet-button',  ->
          t.format 'show-less-active-boards-count', { lessActiveCount }


  orgAdComponent: =>
    props =
      billingUrl: @props.billingUrl
      dismissAd: @props.dismissAd

    React.createElement OrganizationBoardsAd, props



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-section-component.coffee